import { render, staticRenderFns } from "./content-administrator.vue?vue&type=template&id=4636d671&scoped=true"
import script from "./content-administrator.ts?vue&type=script&lang=ts&external"
export * from "./content-administrator.ts?vue&type=script&lang=ts&external"
import style0 from "./content-administrator.less?vue&type=style&index=0&id=4636d671&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4636d671",
  null
  
)

export default component.exports